import {bindActionCreators, type Dispatch} from 'redux';
import {connect} from 'react-redux';

import {getCurrentTeamId} from 'mattermost-redux/selectors/entities/teams';

import {getCurrentUserId} from 'mattermost-redux/selectors/entities/users';

import {type GlobalState} from 'mattermost-redux/types/store';
import {type GenericAction} from 'mattermost-redux/types/actions';

import {autocompleteUsersInChannel} from 'actions/views/channel';
import {searchAssociatedGroupsForReference} from 'actions/views/group';
import {autocompleteChannels} from 'actions/channel_actions';

import {getChannel} from 'mattermost-redux/selectors/entities/channels';
import {ChannelType} from '@mattermost/types/channels';

import Textbox from './textbox';

const makeMapStateToProps = () => {
    return (state: GlobalState, ownProps: {channelId: string}) => {
        return {
            currentUserId: getCurrentUserId(state),
            currentTeamId: getCurrentTeamId(state),
            withinDirect: getChannel(state, ownProps.channelId)?.type === ChannelType.Direct,
        };
    };
};

const mapDispatchToProps = (dispatch: Dispatch<GenericAction>) => ({
    actions: bindActionCreators({
        autocompleteUsersInChannel,
        autocompleteChannels,
        searchAssociatedGroupsForReference,
    }, dispatch),
});

export {Textbox as TextboxClass};

export default connect(makeMapStateToProps, mapDispatchToProps, null, {forwardRef: true})(Textbox);
